import { Button, DialogContent } from '@mui/material';
import React, { useState } from 'react'
import { DevelopmentItemErrors } from '../apiClients/DevelopmentClient';
import { useErrorDisplay } from '../components/ErrorDisplay';
import IconButtonEx, { IconButtonExProps } from '../components/IconButtonEx';
import { DevelopmentItem } from '../models/dtos';
import DevelopmentItemCompleteComponent from '../ui-components/DevelopmentItemCompleteComponent';
import { ResponsiveDialog, ResponsiveDialogHeader, StickyDialogActions } from '../components/responsive';

export interface DevelopmentItemCompletePopupProps extends Omit<IconButtonExProps, 'onClick'> {
    developmentItem: DevelopmentItem;
    icon?: JSX.Element;
    onSubmit?: () => void;
}

const DevelopmentItemCompletePopup = ({ developmentItem, icon, onSubmit = () => { }, ...btnProps }: DevelopmentItemCompletePopupProps) => {

    const [ErrorDisplay, setError] = useErrorDisplay();
    const [open, setOpen] = useState<boolean>(false);

    const title = "Complete Plan Item";

    const handleOnChange = () => {

    };

    const handleSubmit = async () => {
        try {
            onSubmit();
            handleClose();

        } catch (error) {
            setError(error, DevelopmentItemErrors.Complete);
        }
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <>
            <ErrorDisplay />
            <IconButtonEx hoverContent={title} size='small' onClick={() => setOpen(true)} {...btnProps}>{icon}</IconButtonEx>

            <ResponsiveDialog aria-labelledby="development-item-complete-title" open={open} fullWidth tabletFullScreen="never" PaperProps={{ sx: { overflow: 'hidden' } }}>
                <ResponsiveDialogHeader id="development-item-complete-title" title={title} />
                <DialogContent sx={{ overflowY: 'auto' }}>
                    <DevelopmentItemCompleteComponent developmentItem={developmentItem} onChange={handleOnChange} />
                </DialogContent>
                <StickyDialogActions phoneLayout="stacked">
                    <Button onClick={handleClose} color="inherit" variant="text">Cancel</Button>
                    <Button onClick={handleSubmit} color="primary" variant="outlined">Submit</Button>
                </StickyDialogActions>
            </ResponsiveDialog>
        </>
    );
}

export default DevelopmentItemCompletePopup
